
export const isIOS = () =>
  typeof navigator !== 'undefined' &&
  /iPad|iPhone|iPod/.test(navigator.userAgent);

export const isAppleDevice = () =>
  typeof navigator !== 'undefined' &&
  (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
    /Macintosh/.test(navigator.userAgent));

export const isReactNativeWebView = () =>
  typeof window !== 'undefined' && !!window.ReactNativeWebView;

/** Opens UPI/deeplink URLs; RN WebViews block custom schemes unless bridged via postMessage. */
export const openExternalLink = (url) => {
  if (!url) return false;

  if (window?.ReactNativeWebView?.postMessage) {
    window.ReactNativeWebView.postMessage(`open_external_link|${url}`);
    return true;
  }

  window.open(url, '_self');
  return false;
};

/** Native app should post `external_link_opened` or `external_link_failed` back to webview. */
export const onNativeExternalLinkResult = (onOpened, onFailed) => {
  const handler = (event) => {
    const msg = typeof event.data === 'string' ? event.data : event.data?.data;
    if (msg === 'external_link_opened') onOpened?.();
    if (msg === 'external_link_failed') onFailed?.();
  };
  window.addEventListener('message', handler);
  document.addEventListener('message', handler);
  return () => {
    window.removeEventListener('message', handler);
    document.removeEventListener('message', handler);
  };
};
